import { darken } from "polished";
import styled from "styled-components";

const Info = styled.div`
    position: ${({ position }) => position};
    bottom: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 5px;

    ul {
        display: flex;
        flex-direction: row;
        gap: 10px;
    }
`;

const ProjectType = styled.span`
    background-color: ${({ theme, type }) => type === "backend" ? "#575aff" : darken(.2, theme.colors.primary)};
    padding: 2px 5px;
    border-radius: 4px;
    color: white;
`;

export const Technology = styled.li`
    color: white;
    background-color: ${({ color }) => color};
    padding: 2px 5px;
    border-radius: 4px;
`;

export function ProjectInfo({ technologies, type, absolute, centralize }) {
    return (
        <Info position={absolute ? "absolute" : "static"}>
            <ProjectType type={type}>
                {type}
            </ProjectType> | 
            <ul>
                {technologies?.map((tech, i) => (
                    <Technology key={i} color={tech.color}>
                        {tech.name}
                    </Technology>
                ))}
            </ul>
        </Info>
    )
}